import { render } from "./View-Main-Right.vue?vue&type=template&id=27513d25"
import script from "./View-Main-Right.vue?vue&type=script&lang=js"
export * from "./View-Main-Right.vue?vue&type=script&lang=js"

import "./View-Main-Right.vue?vue&type=style&index=0&id=27513d25&lang=css"
script.render = render

export default script